
export const pitchNames = [ "", "Red", "Yellow", "Blue" ];